import { render, staticRenderFns } from "./PastSubsidence.vue?vue&type=template&id=62796dee"
import script from "./PastSubsidence.vue?vue&type=script&lang=js"
export * from "./PastSubsidence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports